import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import * as tios from './tios';
import * as simulator from './simulator';

export default class PatternNode extends BaseNode {
    constructor() {
        super();
        this.name = 'LED Pattern';
        this.id = 'node_pat';
        this.icon = 'MdOutlineLightMode';
        this.linkedFeature = 'general';

        this.inputs = [
            {
                name: 'Play Pattern',
                portId: 'pat.play',
                params: [
                    {
                        name: 'patternstring',
                        dataType: TibboDataType.STRING,
                        default: 'B*',
                        regex: /^[bBrRgG\-~*]+$/,
                    },
                ],
            },
        ];

        const settings: Setting[] = [
            {
                id: 'CANINT',
                name: 'Can Interrupt',
                settingType: SettingType.OPTION,
                required: true,
                options: [
                    {
                        name: 'Cannot Interrupt',
                        value: 'PL_PAT_NOINT',
                    },
                    {
                        name: 'Can Interrupt',
                        value: 'PL_PAT_CANINT',
                    },
                ],
                default: 'PL_PAT_CANINT',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const project: ProjectConfiguration = this.project;
            const links = project.getNodeLinks(this, 'pat.play');
            if (links.length > 0) {
                const link = links[0];
                const printstr = project.getNodeParameterValue(this, 'patternstring');
                return `LED pattern ${printstr}`;
            }
        }
        return super.getSettingValue(settingId);
    }

    getName(): string {
        const project: ProjectConfiguration = this.project;
        const links = project.getNodeLinks(this, 'pat.play');
        if (links.length > 0) {
            const link = links[0];
            const printstr = project.getNodeParameterValue(this, 'patternstring');
            return `LED pattern ${printstr}`;
        }
        return this.name;
    }

    getCodeBlocks(): CodeBlock[] {
        if (this.project.runtime === 'simulator') {
            return simulator.getCodeBlocks(this);
        }
        return tios.getCodeBlocks(this);
    }

    getDetails(): string {
        return `
##### LED Pattern
This block loads a new LED pattern to play on the currently selected LED channel.


'-': both LEDs off

'R' or 'r': red LED on

'G' or 'g': green LED on

'B' or 'b': both LEDs on

'~': looped pattern (can reside anywhere in the pattern string)

'&ast;': double-speed pattern (can reside anywhere in the pattern string). You can use this symbol twice to x4 speed. Adding even more '*' will not have any effect.`;
    }
}
